"use strict";

exports.__esModule = true;
exports.DeviceDataItemBatchSubscription = void 0;
var _react = _interopRequireDefault(require("react"));
var _API = require("../../API");
var _excluded = ["deviceUuid", "dataItems"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var DeviceDataItemBatchSubscription = exports.DeviceDataItemBatchSubscription = function DeviceDataItemBatchSubscription(_ref) {
  var deviceUuid = _ref.deviceUuid,
    dataItems = _ref.dataItems,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_API.RealtimeBatchSubscription, _extends({
    key: deviceUuid,
    channels: dataItems.reduce(function (a, dataItem) {
      a[deviceUuid + "-" + dataItem.name] = ["connectdata", {
        entity: {
          device: deviceUuid,
          type: dataItem.type_ns ? dataItem.type_ns + ":" + dataItem.type : dataItem.type,
          name: dataItem.name
        }
      }];
      return a;
    }, {})
  }, extra));
};